import {Location} from "@angular/common";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {HubConnection} from "@microsoft/signalr";
import {SignalRConnectionResolver} from "./signal-r-connection.resolver";
import {Injectable} from "@angular/core";
import {MesHttpInterceptor} from "./mes-http.interceptor";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiMessage, ApiResponse} from "./api-response/api-response.model";
import {UserService} from "./system/users/user.service";
import {MesNotificationService} from "./mes-notification.service";

@Injectable({
  providedIn: 'root'
})
export class ProgressHubResolver extends SignalRConnectionResolver {

  constructor(location: Location, private mesNotificationService: MesNotificationService, private mesHttpInterceptor: MesHttpInterceptor, private userService: UserService) {
    super(location, 'progress');
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<HubConnection> {
    const resolve = super.resolve(route, state);

    resolve.then(connection => {
      this.sendUserId(connection);

      connection.on('progress', data => {
        this.mesNotificationService.progress$.next(data);
      });

      connection.on('responsemessage', data => {
        if (data.errors?.length || data.warnings?.length || data.informations?.length) {
          const error = this.mapToHttpErrorResponse(data);
          this.mesHttpInterceptor.handleError(error);
        }
      });

      connection.on('queue', data => {
        this.mesNotificationService.queue$.next(data);
      });
    });

    return resolve;
  }

  private sendUserId(connection: HubConnection) {
    this.userService.getCurrent().subscribe(user => {
      if(user?.data?.Id){
        connection.invoke('registeruser', user.data.Id).then();
      }
    });
  }

  private mapToHttpErrorResponse(data: any): HttpErrorResponse {
    let errors: ApiMessage[] = [];
    data.errors.forEach(error => {
      errors.push(new ApiMessage({Code: error.code, Messages: error.messages, Model: error.model}));
    });
    let warnings: ApiMessage[] = [];
    data.warnings.forEach(warning => {
      warnings.push(new ApiMessage({Code: warning.code, Messages: warning.messages, Model: warning.model}));
    });
    let informations: ApiMessage[] = [];
    data.informations.forEach(information => {
      informations.push(new ApiMessage({Code: information.code, Messages: information.messages, Model: information.model}));
    });

    const apiResponse = new ApiResponse({Errors: errors, Warnings: warnings, Informations: informations});
    return new HttpErrorResponse({error: apiResponse, status: data.code});
  }
}
